import Nullstack from 'nullstack';
export default function IconTrafficLightsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-traffic-lights-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4c.912 -1.219 2.36 -2 4 -2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1 -10 0v-10"
  }), "   ", Nullstack.element("path", {
    d: "M12 8a1 1 0 1 0 -1 -1"
  }), "   ", Nullstack.element("path", {
    d: "M11.291 11.295a1 1 0 0 0 1.418 1.41"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "17",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}